import React, {useState} from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Repositorio.css';
import '../../filecard.css';

export default function Repositorio() {
  const [searchTerm, setSearchTerm] = useState('');
  const [cursoSelecionado, setCursoSelecionado] = useState('');
  const [filteredMonografias, setFilteredMonografias] = useState([]);

  const monografiasPorCurso = {
    administracao: [
      {
        title: 'Dificuldades Na Gestão De Pessoas Do Nível Operacional Na '+
        'Atividade De Cafeicultura No Município De Itamaraju-Ba',
        author: 'Allan Oliveira Santos',
        link: '/assets/monografias/administracao/ALLAN OLIVEIRA SANTOS.pdf',
        curso: 'administracao',
      },
      {
        title: 'Recursos Humanos: Estudo Das Práticas De Gestão De Pessoas '+
        'Em Uma Empresa Do Ramo De Materiais De Construção No Município'+
        ' De Itamaraju - Ba',
        author: 'Almerindo De Acizio Pires',
        link: '/assets/monografias/administracao/ALMERINDO DE ACIZIO PIRES.pdf',
        curso: 'administracao',
      },
      {
        title: 'Comunicação Empresarial',
        author: 'Amanda Souza Brandão',
        link: '/assets/monografias/administracao/AMANDA SOUZA BRANDÃO.pdf',
        curso: 'administracao',
      },
      {
        title: 'Gestão Rural: Conhecendo O Micro Produtor De Cacau Da Cidade '+
        'De Itamaraju Bahia E Suas Práticas Administrativas',
        author: 'André Lucas Lopes França',
        link: '/assets/monografias/administracao/ANDRÉ LUCAS LOPES FRANÇA.pdf',
        curso: 'administracao',
      },
      {
        title: 'Gestão Financeira: Enfoque Nas Carteiras De Recebimento No '+
        'Fluxo De Caixa Em Empresas Na Cidade De Itamaraju/Ba.',
        author: 'Daniele Carmo Scopel',
        link: '/assets/monografias/administracao/DANIELE CARMO SCOPEL.pdf',
        curso: 'administracao',
      },
      {
        title: 'Gestão De Materiais: Enfoque Na Análise De Produtos Frios E'+
        ' Congelados Em Um Supermercado Localizado Na Cidade De '+
        'Itamaraju/Ba 2020.',
        author: 'Donato Amaral Dos Anjos',
        link: '/assets/monografias/administracao/DONATO AMARAL DOS ANJOS.pdf',
        curso: 'administracao',
      },
      {
        title: 'Gestão De Estoque: Proposta De Intervenção Em Uma Microempresa'+
        ' De Manutenção De Veículos Automotores Localizada'+
        ' Na Cidade De Itamaraju Ba',
        author: 'Francielle Dos Santos Lerbach',
        link: '/assets/monografias/administracao/FRANCIELLE'+
        ' DOS SANTOS LERBACH.pdf',
        curso: 'administracao',
      },
      {
        title: 'Análise Do Fluxo Logístico Das Amêndoas De Cacau'+
        ' Com Foco Na Otimização Dos Recursos Disponíveis',
        author: 'Joseana Almeida Bonfim',
        link: '/assets/monografias/administracao/JOSEANA ALMEIDA BONFIM.pdf',
        curso: 'administracao',
      },
      {
        title: 'Gestão De Pessoas: Uma Análise Do Clima Organizacional Em '+
        'Uma Empresa Do Ramo Do Agronegócio No Município De Itamaraju-Ba',
        author: 'Letícia Soares Lacerda',
        link: '/assets/monografias/administracao/LETÍCIA SOARES LACERDA.pdf',
        curso: 'administracao',
      },
      {
        title: 'Segurança Do Trabalho: Nas Micro E Pequenas Empresas Do Ramo '+
        'De Atividade De Oficinas Mecânicas De Itamaraju-Ba',
        author: 'Lissandra Rodrigues Dos Santos',
        link: '/assets/monografias/administracao/LISSANDRA RODRIGUES.pdf'+
        ' DOS SANTOS.pdf',
        curso: 'administracao',
      },
      {
        title: 'Administração Estratégica Voltada Para A Captação De Clientes:'+
        ' Um Estudo Em Uma Empresa Do Ramo De Consórcios Em Itamaraju- Ba',
        author: 'Lorena Silva Alves',
        link: '/assets/monografias/administracao/LORENA SILVA ALVES.pdf',
        curso: 'administracao',
      },
      {
        title: 'Marketing Estratégico Como Diferencial Competitivo Em Uma '+
        'Empresa Do Ramo Da Moda No Município De Itamaraju-Ba',
        author: 'Sandy Guimarães André Alencar',
        link: '/assets/monografias/administracao/SANDY GUIMARÃES ANDRÉ'+
        ' ALENCAR.pdf',
        curso: 'administracao',
      },
      {
        title: 'Tecnologia Da Informação Como Ferramenta De Apoio À Secretaria'+
        ' Da Escola Municipal Duque De Caxias',
        author: 'Cinthia Nascimento Novais',
        link: '/assets/monografias/administracao/CINTHIA NASCIMENTO NOVAIS.pdf',
        curso: 'administracao',
      },
      {
        title: 'Reestruturação Da Itavel Veículos: Uma Proposta Para'+
        ' A Sua Competitividade',
        author: 'Francisco Fonseca Dias',
        link: '/assets/monografias/administracao/FRANCISCO FONSECA DIAS.pdf',
        curso: 'administracao',
      },
      {
        title: 'A Rotatividade De Pessoal E Seus Impactos Na Administração '+
        'Pública Da Prefeitura Municipal De Prado-Ba',
        author: 'Fernanda Barreto Santos',
        link: '/assets/monografias/administracao/FERNANDA BARRETO SANTOS.pdf',
        curso: 'administracao',
      },
      {
        title: 'Marketing De Serviços - Expectativas E Percepções Dos Usuários'+
        ' De Serviços Da Unimed Extremo Sul',
        author: 'Jany Da Silva Maulaz',
        link: '/assets/monografias/administracao/JANY DA SILVA MAULAZ.pdf',
        curso: 'administracao',
      },
      {
        title: 'Estratégias De Marketing Local: Uma Alternativa Para '+
        'Competitividade Do Ponto Frio Digital De Itamaraju-Ba',
        author: 'Jarles Do Amaral Lima',
        link: '/assets/monografias/administracao/JARLES DO AMARAL LIMA.pdf',
        curso: 'administracao',
      },
      {
        title: 'Gestão Da Qualidade Como Alternativa Para Redução Da Evasão '+
        'Estudantil No Polo Da Universidade Aberta Do Brasil De Itamaraju',
        author: 'Marcia Dos Santos Pires',
        link: '/assets/monografias/administracao/MARCIA DOS SANTOS PIRES.pdf',
        curso: 'administracao',
      },
      {
        title: 'O Controle Interno Como Instrumento De Eficácia Para A '+
        'Despesa Pública Da Prefeitura Municipal De Itamaraju/Ba.',
        author: 'Moabe Gregório Da Silva',
        link: '/assets/monografias/administracao/MOABE GREGÓRIO DA SILVA.pdf',
        curso: 'administracao',
      },
      {
        title: 'Avaliação Dos Recebimentos Da Empresa Farmácia Mariana Ltda.',
        author: 'Wilian Pires Dos Santos',
        link: '/assets/monografias/administracao/WILIAN PIRES DOS SANTOS.pdf',
        curso: 'administracao',
      },
    ],
    direito: [
      {
        title: 'A Contribuição da Melhoria Como Instrumento de Viabilidade...',
        author: 'Fabrício Ghil Frieber',
        link: '/assets/monografias/direito/FABRÍCIO GHIL FRIEBER.pdf',
        curso: 'Direito',
      },
      {
        title: 'Adoção Homoafetiva',
        author: 'Joana Angélica Sampaio',
        link: '/assets/monografias/direito/'+
        'JOANA ANGÉLICA SAMPAIO SARMENTO MENEZES.pdf',
        curso: 'Direito',
      },
      {
        title: 'Inseminação Heteróloga: Do anonimato dos doadores...',
        author: 'Lidiane Barros Monfardine',
        link: '/assets/monografias/direito/LIDIANI BARROS MONFARDINE.pdf',
        curso: 'Direito',
      },
      {
        title: 'O Direito ao Ensino Fundamental e sua Relação...',
        author: 'Mailton Vieira Franco',
        link: '/assets/monografias/direito/MAILTON VIEIRA FRANCO.pdf',
        curso: 'Direito',
      },
      {
        title: 'O Tribunal Penal Internacional: aspectos históricos...',
        author: 'Mariela de Mattos Moreau',
        link: '/assets/monografias/direito/MARIELA DE MATTOS MOREAU.pdf',
        curso: 'Direito',
      },
      {
        title: 'Licitação: Transparência na Gestão Pública',
        author: 'Marli Oliveira de Jesus',
        link: '/assets/monografias/direito/MARLI OLIVEIRA DE JESUS.pdf',
        curso: 'Direito',
      },
      {
        title: 'Controle Social da Administração Pública',
        author: 'Milton Ferreira Guimarães',
        link: '/assets/monografias/direito/MILTON FERREIRA GUIMARÃES.pdf',
        curso: 'Direito',
      },
      {
        title: 'A desapropriação Urbanística e o Plano Diretor',
        author: 'Nayanna Vasconcelos Lima',
        link: '/assets/monografias/direito/NAYANNA VASCONCELOS LIMA.pdf',
        curso: 'Direito',
      },
      {
        title: 'O Instituto do Livramento Condicional',
        author: 'Nilson André Cerqueira Menezes',
        link: '/assets/monografias/direito/NILSON ANDRÉ CERQUEIRA MENEZES.pdf',
        curso: 'Direito',
      },
      {
        title: 'Violência Doméstica, Cometida por Marido Contra Esposa, Ambos'+
        ' Militares. Justiça Comum ou Militar?',
        author: 'Carlos Eduardo Barbosa Da Silva',
        link: '/assets/monografias/direito/CARLOS EDUARDO BARBOSA DA SILVA.pdf',
        curso: 'Direito',
      },
      {
        title: 'A Extinção da Punibilidade e a Prescrição Penal',
        author: 'Fernando Torres Ferreira',
        link: '/assets/monografias/direito/FERNANDO TORRES FERREIRA.pdf',
        curso: 'Direito',
      },
      {
        title: 'Municipalização - Responsabilidade'+
        ' Objetiva pelo Trânsito Seguro',
        author: 'Gilson Paixão Silva Santos',
        link: '/assets/monografias/direito/GILSON PAIXÃO SILVA SANTOS.pdf',
        curso: 'Direito',
      },
      {
        title: 'A aplicabilidade do Princípio da Insignificância'+
        ' no Direito Penal',
        author: 'Gleidimara Gonçalves De Nazareth',
        link: '/assets/monografias/'+
        'direito/GLEIDIMARA GONÇALVES DE NAZARETH.pdf',
        curso: 'Direito',
      },
      {
        title: 'Restrições ou Limitações dos Direitos Políticos',
        author: 'Gustavo Gouveia Mota',
        link: '/assets/monografias/direito/GUSTAVO GOUVEIA MOTA.pdf',
        curso: 'Direito',
      },
      {
        title: 'O Alcance do Direito À Imagem',
        author: 'Gutemberg Alarito Galavotti',
        link: '/assets/monografias/direito/GUTEMBERG ALARITO GALAVOTTI.pdf',
        curso: 'Direito',
      },
      {
        title: 'Direito Estável: Direitos e Deveres',
        author: 'Isbela America Sincora Da Paixão',
        link: '/assets/monografias/direito/ISBELA '+
        'AMERICA SINCORA DA PAIXÃO.pdf',
        curso: 'Direito',
      },
      {
        title: 'Apropriação Indébita das Contribuições '+
        'Previdênciárias à Luz do Caput do Artigo 168-A do Código Penal',
        author: 'Ítalo Marques Nascimento',
        link: '/assets/monografias/direito/ÍTALO MARQUES NASCIMENTO.pdf',
        curso: 'Direito',
      },
      {
        title: 'Os Direitos Humanos e a Polícia: É a Polícia '+
        'protagonista dos Direitos Humanos?',
        author: 'Jan Ribeiro Matos',
        link: '/assets/monografias/direito/JAN RIBEIRO MATOS.pdf',
        curso: 'Direito',
      },
      {
        title: 'Lei Nº 12.015/2009: Um Marco Modificador Quanto Ao Crime'+
        ' De Estupro (Art. 213 CP/1940), E Inovador Quanto Ao Crime De Estupro'+
        ' De Vulnerável (Art. 217-A CP/1940).',
        author: 'Jamile De Oliveira Lopes',
        link: '/assets/monografias/direito/JAMILE DE OLIVEIRA LOPES.pdf',
        curso: 'Direito',
      },
      {
        title: 'A Efetividade Do Processo Penal Brasileiro: Comentários Sobre '+
        'A Duração Razoável E A Dilação Processual Indevida',
        author: 'Adriano Medeiros Mascarenhas',
        link: '/assets/monografias/direito/ADRIANO MEDEIROS MASCARENHAS.pdf',
        curso: 'Direito',
      },
    ],
    enfermagem: [
      {
        title: 'Doação De Sangue A Otica Dos Acadêmicos De'+
        ' Uma Ies No Extremo Sul Da Bahia',
        author: 'Adalgiza Santos Barbosa Santos',
        link: '/assets/monografias/enfermagem/Adalgiza'+
        ' Santos Barbosa Santos.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Código De Ética De Enfermagem: A Condução'+
        ' Segura Nas Ações Do Profissional.',
        author: 'Alana Dias Pereira',
        link: '/assets/monografias/enfermagem/Alana Dias Pereira.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Compreendendo A Pré-Eclâmpsia E Eclâmpsia',
        author: 'Alexsandra Ferreira Almeida Jardim',
        link: '/assets/monografias/enfermagem/Alexsandra'+
        ' Ferreira Almeida Jardim.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Tanatologia: Relatos De Nove Profissionais '+
        'Da Área Da Saúde Que Conviveram Com Paciente Na Fase Terminal.',
        author: 'Aline Alves de Souza Cardoso',
        link: '/assets/monografias/enfermagem/Aline Alves de Souza Cardoso.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Os Novos Medicamentos Utilizados No Tratamento '+
        'Da Asma Na Emergência',
        author: 'Amanda Menezes Nascimento',
        link: '/assets/monografias/enfermagem/Amanda Menezes Nascimento.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Índice De Psa No Município De Itamaraju/Ba No '+
        'Período De 2007 A 2010',
        author: 'Ana Cardoso de jesus Queiroz',
        link: '/assets/monografias/enfermagem/Ana Cardoso de jesus Queiroz.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'A Importância Dos Exames Para Detecção E Prevenção '+
        'Do Câncer De Próstata',
        author: 'Ana Odile Dantas de Paula',
        link: '/assets/monografias/enfermagem/Ana Odile Dantas de Paula.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Climatério: Um Impacto Na Vida Da Mulher',
        author: 'Ana Paula Freitas Tavares',
        link: '/assets/monografias/enfermagem/Ana Paula Freitas Tavares.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Motivos Que Levam Os Hipertensos A Abandonar O Tratamento'+
        ' Na Unidade De Saúde No Bairro Marotinho Do Município De Itamaraju/Ba',
        author: 'Angela Azevedo Souza Noronha',
        link: '/assets/monografias/enfermagem/Angela Azevedo Souza Noronha.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'O Papel Do Profissional De Enfermagem Na Prevenção Do Uso De'+
        ' Drogas E As Perspectivas “Estratégia De Saúde Da Família” No'+
        ' Município De Itamaraju — Ba',
        author: 'Angela de Jesus Rodrigues Grippa',
        link: '/assets/monografias/enfermagem/Angela de Jesus '+
        'Rodrigues Grippa.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Assistência À Parturiente: Importância Do Acompanhante '+
        'No Pré-Parto, Parto E Pós-Parto Humanizado',
        author: 'Aparecida Pianissola dos Santos',
        link: '/assets/monografias/enfermagem/Aparecida '+
        'Pianissola dos Santos.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Depressão: Sintomatologia Em Acadêmicos Da Área Da Saúde',
        author: 'Paulo Jeferson Alves Dos Santos',
        link: '/assets/monografias/enfermagem/Paulo Jeferson '+
        'Alves Dos Santos.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Primeiros Socorros: Um Estudo Da Realidade Profissional '+
        'Dos Educadores No Município De Guaratinga - Ba',
        author: 'Eloane Carvalho Da Cruz',
        link: '/assets/monografias/enfermagem/ELOANE CARVALHO DA CRUZ.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Representação Social Da Hemodiálise Na Qualidade De '+
        'Vida Do Paciente Renal Crônico',
        author: 'Betânia dos Santos Tanajura',
        link: '/assets/monografias/enfermagem/Betânia dos Santos Tanajura.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Crise Hipertensiva: Uma Revisão Bibliográfica',
        author: 'Carlos Ivon Costa',
        link: '/assets/monografias/enfermagem/Carlos Ivon Costa.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'As Dificuldades Das Primigestas Na Amamentação '+
        'E As Falhas Na Orientação Da Enfermagem',
        author: 'Claudio Cordeiro de Oliveira Lima',
        link: '/assets/monografias/enfermagem/Claudio Cordeiro'+
        ' de Oliveira Lima.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Orientações Ao Cuidador Domiciliar De '+
        'Pessoas Incapacitadas Por AVE',
        author: 'Cleber Cunha Freitas',
        link: '/assets/monografias/enfermagem/Cleber Cunha Freitas.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Orientações Ao Cuidador Domiciliar De '+
        'Pessoas Incapacitadas Por AVE',
        author: 'Juliana Andrade Cardoso e Silva',
        link: '/assets/monografias/enfermagem/Juliana Andrade'+
        ' Cardoso e Silva.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Relato De Dois Pacientes Sobre O Tratamento'+
        ' Para O Câncer De Canal Anal',
        author: 'Deniandro Pirola',
        link: '/assets/monografias/enfermagem/Deniandro Pirola.pdf',
        curso: 'enfermagem',
      },
      {
        title: 'Climatério: Um Impacto Na Sexualidade Feminina',
        author: 'Daniela Mara Souza Prates',
        link: '/assets/monografias/enfermagem/Daniela Mara Souza Prates.pdf',
        curso: 'enfermagem',
      },
    ],
    farmacia: [],
    gastronomia: [
      {
        title: 'O Conceito Do Comfort Food Na Gastronomia '+
        'Uma Revisão Bibliográfica',
        author: 'Ana Claúdia Luz Rodrigues De Oliveira',
        link: '/assets/monografias/gastronomia/ANA CLAÚDIA LUZ'+
        ' RODRIGUES DE OLIVEIRA.pdf',
        curso: 'gastronomia',
      },
      {
        title: 'Desperdício Alimentar: A Educação '+
        'Como Conscientização Sustentável',
        author: 'Beatriz Ribeiro Cruz',
        link: '/assets/monografias/gastronomia/BEATRIZ RIBEIRO CRUZ.pdf',
        curso: 'gastronomia',
      },
      {
        title: 'Alimentação Saudável E O Retorno Da Horta Doméstica',
        author: 'Hélio Gonçalves De Souza',
        link: '/assets/monografias/gastronomia/HÉLIO GONÇALVES DE SOUZA.pdf',
        curso: 'gastronomia',
      },
      {
        title: 'Marketing: Um Estudo De Caso Da Franchising (Franquia)'+
        ' No Ramo De Doces Finos No Município De Itamaraju-Ba',
        author: 'Isabelly Souza Gomes',
        link: '/assets/monografias/gastronomia/ISABELLY SOUZA GOMES.pdf',
        curso: 'gastronomia',
      },
      {
        title: 'Sustentabilidade Na Gastronomia: Redução Do '+
      'Consumo De Alimentos Processados',
        author: 'Maria Madalena Oliva Souza Pires',
        link: '/assets/monografias/gastronomia/MARIA MADALENA '+
        'OLIVA SOUZA PIRES.pdf',
        curso: 'gastronomia',
      },
    ],
    medicinaVeterinaria: [],
    odontologia: [],
    radiologia: [],
  };

  // Junta todas as monografias em um único array
  const todasMonografias = Object.values(monografiasPorCurso).flat();

  const handleSearch = () => {
    let resultados = todasMonografias;

    if (cursoSelecionado) {
      resultados = resultados.filter(
          (m) => m.curso.toLowerCase() === cursoSelecionado );
    }

    if (searchTerm) {
      resultados = resultados.filter((m) =>
        m.title.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    setFilteredMonografias(resultados);
  };

  const handleFiltroCurso = (curso) => {
    setCursoSelecionado(curso);
    setSearchTerm('');
    const resultados = todasMonografias.filter(
        (m) => m.curso.toLowerCase() === curso);
    setFilteredMonografias(resultados);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <>
      <Header />
      <div className='title-page'>
        <div className='page-title-wrap'>
          <img src='https://i.imgur.com/8n3nyYR.png' alt='decoração' />
          <h1>REPOSITÓRIO TCC</h1>
          <img src='https://i.imgur.com/8n3nyYR.png' alt='decoração' />
        </div>
      </div>

      <div className='filtro-botoes'>
        {Object.keys(monografiasPorCurso).map((curso) => (
          <button
            key={curso}
            className={`botao-filtro ${
              cursoSelecionado === curso ? 'ativo' : ''
            }`}
            onClick={() => handleFiltroCurso(curso)}
          >
            {curso.charAt(0).toUpperCase() +
              curso.slice(1).replace(/([A-Z])/g, ' $1')}
          </button>
        ))}
      </div>

      <div className='seach col-sm-12 col-md-6 col-md-offset-3'>
        <div className='input-group text-center'>
          <input
            type='text'
            className='form-control'
            id='pesquisar'
            placeholder='Digite aqui o nome da obra'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyPress}
          />
          <span className='input-group-btn'>
            <button type='button' className='btn-search' onClick={handleSearch}>
              <i className='fa btn-pesquisa'>Pesquisar</i>
            </button>
          </span>
        </div>
      </div>

      {cursoSelecionado && (
        <div className='title-curso'>
          <h2>
            {cursoSelecionado.charAt(0).toUpperCase() +
              cursoSelecionado.slice(1)}
          </h2>
        </div>
      )}

      <div className='file-card-container'>
        {(filteredMonografias.length > 0 || searchTerm ||
          cursoSelecionado? filteredMonografias :
           todasMonografias
        ).map((monografia, index) => (
          <div className='file-card' key={index}>
            <h1 className='file-card-title'>{monografia.title}</h1>
            <p className='file-card-subtitle'>{monografia.author}</p>
            <div className='file-card-divison'></div>
            <a
              href={monografia.link}
              className='file-card-link file-card-link-custom'
              target='_blank'
              rel='noopener noreferrer'
            >
              <p className='link-abrir'>Abrir</p>
            </a>
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
}
